import { INITIALIZE_FORM } from '../actionTypes';
import { actions } from '../reducer';

export default (values) => actions[INITIALIZE_FORM](values);
